import React from 'react';

import SidebarState from 'context/Sidebar/SidebarState';

import Sidebar from 'components/Sidebar/Sidebar';
import Main from 'components/Main/Main';

export default function Layout(props) {
    return (
        <SidebarState>
            <div className="d-lg-flex">
                <Sidebar />
                <Main>
                    {props.children}
                </Main>
            </div>
        </SidebarState>
    )
}
